import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getClassifyInsurable } from '@flecto/api/shared'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  itemName: string
  categoryId?: ParameterID
}

export function useMutationClassifyInsurable() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ itemName, categoryId }: MutationPayload) => {
      const cachedData = queryClient.getQueryData<{ insured: boolean }>([
        'classifyInsurable',
        itemName,
        categoryId,
      ])

      if (cachedData) return cachedData

      return getClassifyInsurable(itemName, categoryId)
    },
    onSuccess: (data, { itemName, categoryId }) => {
      queryClient.setQueryData(
        ['classifyInsurable', itemName, categoryId],
        data
      )
    },
  })
}
